export const initialKpiPerformaceTimeBySatus = () => ({
    listAll: [],
    currentMonthSales: [],
    lastMonthSales: [],
    loading: false,
});

function groupByMonth(data) {
    if (!Array.isArray(data)) return [];

    const groupedData = new Map();

    data.forEach((item) => {
        // Ajuste aqui se o campo de data for outro
        const rawDate =
            item.data ||
            item.dataPedido ||
            item.createdAt ||
            item.updatedAt;

        if (!rawDate) {
            console.warn('Item sem data válida:', item);
            return;
        }

        const date = new Date(rawDate);
        if (Number.isNaN(date.getTime())) {
            console.warn('Data inválida:', rawDate);
            return;
        }

        const month = date.getMonth() + 1; // 1..12
        const year = date.getFullYear();

        const key = `${year}-${String(month).padStart(2, '0')}`;

        if (!groupedData.has(key)) {
            groupedData.set(key, {
                month,
                year,
                records: []
            });
        }

        groupedData.get(key).records.push(item);
    });

    // Retorna ordenado cronologicamente
    return Array.from(groupedData.values()).sort(
        (a, b) => (a.year * 12 + (a.month - 1)) - (b.year * 12 + (b.month - 1))
    );
}


export const kpiPerformaceTimeBySatus = (currentState, action) => {
    let kpiPerformanceTimeBySatus = {
        listAll: [],
        loading: action.loading ?? currentState.loading,
    };

    const currentDate = action.selectedDate
        ? new Date(action.selectedDate)
        : new Date();

    const currentMonth = currentDate.getMonth() + 1; // 1..12
    const currentYear = currentDate.getFullYear();
    const currentDay = currentDate.getDate();

    kpiPerformanceTimeBySatus.selectedDate = currentDate;
    kpiPerformanceTimeBySatus.currentMonth = currentMonth;
    kpiPerformanceTimeBySatus.currentYear = currentYear;
    kpiPerformanceTimeBySatus.currentDay = currentDay;
    kpiPerformanceTimeBySatus.date = new Date();
    kpiPerformanceTimeBySatus.isCurrentMonth =
        currentMonth === kpiPerformanceTimeBySatus.date.getMonth() + 1 &&
        currentYear === kpiPerformanceTimeBySatus.date.getFullYear();

    kpiPerformanceTimeBySatus.listAll = action.kpiPerformanceTimeBySatus || [];
    kpiPerformanceTimeBySatus.compareWith = action.compareWith;

    // Agrupa por ANO + MÊS
    const groupedData = groupByMonth(kpiPerformanceTimeBySatus.listAll);

    // Lista completa de meses
    kpiPerformanceTimeBySatus.monthSales = groupedData;

    // Mês atual
    kpiPerformanceTimeBySatus.currentMonthSales =
        groupedData.find(
            e => e.month === currentMonth && e.year === currentYear
        )?.records || [];

    // Calcula mês anterior considerando virada de ano
    const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
    const previousYear = currentMonth === 1 ? currentYear - 1 : currentYear;

    kpiPerformanceTimeBySatus.lastMonthSales =
        groupedData.find(
            e => e.month === previousMonth && e.year === previousYear
        )?.records || [];

    return {
        ...currentState,
        kpiPerformanceTimeBySatus
    };
};

